// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownTrigger_container__1wmjQ","content":"DropdownTrigger_content__aDTpB"};